export default "__VITE_ASSET__CVbCG02A__"